module.exports = __webpack_public_path__ + "static/img/26920.0a82468.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/education/26920.png
// module id = GcGf
// module chunks = 0